<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Facturador de Ventas GNV</div>
    <div class="box-container">
      <div class="row">
        <div class="col-lg-8"></div>
        <div class="col-lg-2">
          <div>Fecha documento</div>
          <input type="date" class="form-control" v-model="fecha_doc" :min="fecha_doc_min" :max="fecha_doc_max"
            @change="onFechaDocChange" @blur="onFechaDocBlur" required />
        </div>
        <div class="col-lg-2">
          <div>Hora documento</div>
          <input type="time" class="form-control" v-model="hora_doc" @change="onHoraDocChange" @blur="onHoraDocBlur"
            required />
        </div>
      </div>

      <div>
        <div class="label">Cliente</div>
        <div>
          <Select2 v-model="cliente" :options="lista_clientes" @select="selectCliente($event)" />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>Tipo de venta</div>
          <div>
            <select class="form-control" v-model="tipo_venta">
              <option v-for="item in lista_tipo_venta" :key="item._id" :value="item._id">
                {{ item.codigo }} - {{ item.descripcion }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-6">
          <div>Método de pago</div>
          <div>
            <select class="form-control" v-model="metodo_pago">
              <option v-for="item in lista_metodo_pago" :key="item._id" :value="item._id">
                {{ item.codigo }} - {{ item.descripcion }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>Uso de CFDI</div>
          <div>
            <select class="form-control" v-model="uso_cfdi">
              <option v-for="item in lista_uso_cfdi" :key="item._id" :value="item._id">
                {{ item.codigo }} - {{ item.descripcion }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-lg-6">
          <div>Forma de pago</div>
          <div>
            <select class="form-control" v-model="forma_pago">
              <option v-for="item in lista_forma_pago" :key="item._id" :value="item._id">
                {{ item.codigo }} - {{ item.descripcion }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div v-if="mostrar_periodo">
        <div>Periodicidad</div>
        <div>
          <select class="form-control" v-model="perioricidad">
            <option v-for="item in lista_perioricidad" :key="item._id" :value="item._id">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>

      <div>
        <div>Observaciones</div>
        <div>
          <input class="form-control" v-model="observaciones" />
        </div>
      </div>
    </div>

    <br />
    <table class="center" width="90%">
      <tbody>
        <tr>
          <td colspan="5">
            <div>Facturas/Tickets</div>
          </td>
        </tr>
        <tr>
          <td>
            <div>Cliente</div>
            <div>
              <Select2 v-model="clienteticket" :options="lista_clientes" />
            </div>
          </td>
          <td width="50px">
            <div>&nbsp;</div>
            <button class="btn" @click="limpiarCliente">
              <i class="fa-solid fa-close"></i>
            </button>
          </td>
          <td width="115px">
            <div>Consecutivo</div>
            <input class="form-control" v-model="consecutivo" />
          </td>
          <td width="135px">
            <div>Placa</div>
            <input class="form-control" v-model="placa" />
          </td>
          <td width="135px">
            <div>Fecha inicio</div>
            <input id="fecha_inicio" v-model="fecha_inicio" datatype="fecha" readonly class="form-control" />
          </td>
          <td width="135px">
            <div>Fecha final</div>
            <input id="fecha_final" v-model="fecha_final" datatype="fecha" readonly class="form-control" />
          </td>
          <td width="50px">
            <div>.</div>
            <button class="btn btn-primary" @click="getReporteVentasPendiente">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <br />

    <div style="width: 90%; margin: auto">
      <table class="center area-facturas-titulo table-linea" width="100%">
        <tbody>
          <tr>
            <th width="120px">FECHA.</th>
            <th>TICKET</th>
            <th width="60px" class="text-right">PRECIO</th>
            <th width="75px" class="text-right">CANT.</th>
            <th width="75px" class="text-right">SUB.</th>
            <th width="75px" class="text-right">DESC.</th>
            <th width="75px" class="text-right">TOTAL</th>
            <th width="75px" class="text-center">
              <div v-if="reporte.length > 0">
                <div v-if="!seleccionTodos">
                  <button class="btn btn-info btn-xs" @click="selectAll()">
                    TODOS
                  </button>
                </div>
                <div v-else>
                  <button class="btn btn-danger btn-xs" @click="selectAll()">
                    NINGUNA
                  </button>
                </div>
              </div>
            </th>
          </tr>
        </tbody>
      </table>

      <div class="area-facturas-registro">
        <table width="100%" class="table-linea">
          <tbody>
            <tr v-for="item in reporte" :key="item._id" :value="item._id">
              <td width="120px" style="vertical-align: top">
                <div class="area-facturas-placa-cliente">
                  {{ item.prefijo }} - {{ item.consecutivo }}
                </div>
                <div class="area-facturas-fecha">{{ item.fecha }}</div>
              </td>
              <td style="vertical-align: top">
                <div class="area-facturas-placa-cliente">
                  {{ item.placa_vin }} &nbsp;
                </div>
                <div>{{ item.tercero_nit }}-{{ item.tercero_nombre }}</div>
              </td>
              <td width="60px" class="text-right">
                {{ GLOBAL.FORMATO_MONEY(item.precio) }}
              </td>
              <td width="75px" class="text-right">
                {{ GLOBAL.FORMATO_NUMBER(item.cantidad) }}
                <span class="area-facturas-unidad">
                  {{ item.unidad_codigo }}
                </span>
              </td>
              <td width="75px" class="text-right">
                {{ GLOBAL.FORMATO_MONEY(item.venta_subtotal) }}
              </td>
              <td width="75px" class="text-right">
                {{ GLOBAL.FORMATO_MONEY(item.descuento_total) }}
              </td>
              <td width="75px" class="text-right">
                {{ GLOBAL.FORMATO_MONEY(item.venta_total) }}
              </td>
              <td width="75px" class="text-center">
                <div v-if="item.movimiento_id == null">
                  <button v-if="!item.selected" @click="selectMe(item, false)" class="btn btn-primary btn-sm">
                    <i class="fa-solid fa-plus"></i>
                  </button>
                  <button v-if="item.selected" @click="deselectMe(item, false)" class="btn btn-danger btn-sm">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <table width="100%">
        <tbody>
          <tr>
            <td colspan="3" class="pad10-t" style="vertical-align: top">
              <div>
                <table class="center" width="90%">
                  <tbody>
                    <tr>
                      <td colspan="5">
                        <div>Facturas/Tickets</div>
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <td class="area-facturas-totales font-oswald">
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td style="vertical-align: text-top">
                                <div>Factura</div>
                                <div class="area-facturas-texto">
                                  <div v-if="factura_prefijo != null">
                                    <div>{{ factura_prefijo }} -{{ factura_consecutivo }}</div>
                                    <div style="font-size: 11px">{{ factura_uniqueid }}</div>
                                  </div>
                                  <div v-else>[Borrador]</div>
                                </div>
                              </td>

                              <td class="text-right">
                                <table class="right" width="300px">
                                  <tbody>
                                    <tr v-if="total_descuento == 0">
                                      <td>PERSONALIZAR</td>
                                      <td>
                                        <input type="checkbox" v-model="personalizar_precio" @click="recalculo" />
                                      </td>
                                    </tr>

                                    <tr v-if="personalizar_precio">
                                      <td class="area-facturas-label">PRECIO LT, SIN IVA:</td>
                                      <td class="text-right">
                                        <table width="100%">
                                          <tbody>
                                            <tr>
                                              <td>
                                                <input v-model="total_precio_p" style="width: 80px"
                                                  class="text-right" />
                                              </td>
                                              <td width="5px">
                                                <button class="btn btn-xs" @click="recalculo">
                                                  <i class="fa fa-refresh"></i>
                                                </button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>

                                    <tr v-if="personalizar_precio">
                                      <td class="area-facturas-label">PRECIO LT CON IVA:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(total_precio) }}</td>
                                    </tr>

                                    <tr v-if="!personalizar_precio">
                                      <td class="area-facturas-label">PRECIO:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(total_precio) }}</td>
                                    </tr>

                                    <tr v-if="!personalizar_precio">
                                      <td class="area-facturas-label">PRECIO SIN IVA:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(total_precio_sin_impuesto) }}</td>
                                    </tr>

                                    <tr>
                                      <td class="area-facturas-label">CANTIDAD:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_NUMBER(total_cantidad) }}</td>
                                    </tr>

                                    <tr>
                                      <td class="area-facturas-label">CANTIDAD M3:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_NUMBER(total_cantidad_m3) }}</td>
                                    </tr>

                                    <tr>
                                      <td class="area-facturas-label">PRECIO M3:</td>
                                      <td class="text-right">{{ formatDecimal(total_precio_m3, 3) }}</td>
                                    </tr>

                                    <tr>
                                      <td class="area-facturas-label">SUBTOTAL:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(vista_subtal1) }}</td>
                                    </tr>

                                    <tr v-if="false">
                                      <td class="area-facturas-label">DESCUENTO:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(total_descuento) }}</td>
                                    </tr>

                                    <tr>
                                      <td class="area-facturas-label">DESCUENTO SIN IVA:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(vista_descuento) }}</td>
                                    </tr>

                                    <tr v-if="total_descuento != 0">
                                      <td class="area-facturas-label">SUBTOTAL 2:</td>
                                      <td class="text-right">{{ GLOBAL.FORMATO_MONEY(subtotal2) }}</td>
                                    </tr>

                                    <tr>
                                      <td class="area-facturas-label">IMPUESTOS:</td>
                                      <td class="text-right">{{ total_impuesto }}</td>
                                    </tr>

                                    <tr style="border-top: 1px solid #777777">
                                      <td class="area-facturas-texto">TOTAL:</td>
                                      <td class="area-facturas-texto text-right">
                                        {{ formatDecimal(total_facturar, 2) }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="area-facturas-talonario">
                          <table width="100%" class="table">
                            <thead>
                              <tr>
                                <th width="150px">CONSECU.</th>
                                <th>PLACA</th>
                                <th width="150px" class="text-right">PRECIO</th>
                                <th width="150px" class="text-right">CANTIDAD</th>
                                <th width="150px" class="text-right">DESCUENTO</th>
                                <th width="150px" class="text-right">TOTAL</th>
                                <th width="100px" class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="fact in lista_facturar" :key="fact._id" :value="fact._id">
                                <td width="120px" style="vertical-align: top">
                                  <div class="area-facturas-placa-cliente">
                                    {{ fact.prefijo }} - {{ fact.consecutivo }}
                                  </div>
                                  <div class="area-facturas-fecha">{{ fact.fecha }}</div>
                                </td>

                                <td>
                                  <div class="area-facturas-placa">
                                    {{ fact.placa_vin }}&nbsp;
                                  </div>
                                </td>

                                <td width="150px" class="text-right">{{ GLOBAL.FORMATO_MONEY(fact.precio) }}</td>
                                <td width="150px" class="text-right">
                                  {{ GLOBAL.FORMATO_NUMBER(fact.cantidad) }}
                                  <span class="area-facturas-unidad">{{ fact.unidad_codigo }}</span>
                                </td>
                                <td width="150px" class="text-right">
                                  {{ GLOBAL.FORMATO_MONEY(fact.descuento_total) }}
                                </td>
                                <td width="150px" class="text-right">{{ fact.venta_total }}</td>
                                <td width="100px" class="pad10-r text-right">
                                  <div v-if="factura_prefijo == null">
                                    <button @click="deselectMe(fact, false)" class="btn btn-danger btn-sm">
                                      <i class="fa-solid fa-xmark"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="3" class="pad10-t">
              <div class="acciones-bottom">
                <div class="acciones-mensajes">
                  <div v-if="mensaje_guardando" class="acciones-estado">
                    <img src="dist/img/guardando.gif" class="acciones-icon" />
                    <span>Procesando... Por favor espere.</span>
                  </div>

                  <div v-if="mensaje_enviando" class="acciones-estado">
                    <img src="dist/img/enviando.gif" class="acciones-icon" />
                    <span>Estamos enviando la factura.</span>
                  </div>

                  <div v-if="mensaje_consultando" class="acciones-estado">
                    <img src="dist/img/enviando.gif" class="acciones-icon" />
                    <span>Estamos consultando el estado en SAT...</span>
                  </div>

                  <div class="acciones-msg" v-if="despacho_mensaje">
                    {{ despacho_mensaje }}
                  </div>
                </div>

                <div class="acciones-botones" v-if="!procesando">
                  <button class="btn btn-primary" @click="generarFactura" v-if="boton_guardar_visible">
                    <i class="fa-solid fa-file-invoice"></i>
                    <br />Guardar
                  </button>

                  <button v-if="boton_pdf_visible" class="btn" :class="botonPdfClass" @click="abrirPdf">
                    <i class="fa-solid fa-file-pdf"></i>
                    <br />{{ botonPdfTexto }}
                  </button>

                  <button class="btn btn-success" @click="enviarFactura" v-if="boton_enviar_visible"
                    :disabled="boton_enviar_desabilitado">
                    <i class="fa-solid fa-envelope-circle-check"></i>
                    <br />Enviar
                  </button>

                  <button class="btn btn-primary" @click="consultaFactura" v-if="boton_consultar_visible"
                    :disabled="boton_consultar_desabilitado">
                    <i class="fa-solid fa-file-invoice"></i>
                    <br />Consulta
                  </button>
                </div>
              </div>

              <div v-if="!permiso_lista" class="no-permiso">
                {{ person.nombre }}, {{ GLOBAL.MENSAJE.SIN_AUTORIZACION }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import FacturadorService from "../Facturador/FacturadorService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

function buildNowParts() {
  const now = new Date();
  const pad = (v) => String(v).padStart(2, "0");

  const timezoneOffset = now.getTimezoneOffset();

  if (timezoneOffset === 300) {
    now.setHours(now.getHours() - 1);
  }

  const fecha =
    now.getFullYear() +
    "-" +
    pad(now.getMonth() + 1) +
    "-" +
    pad(now.getDate());

  const hora = pad(now.getHours()) + ":" + pad(now.getMinutes());

  return {
    fecha,
    hora,
    fechaHora: `${fecha} ${hora}:00`,
  };
}

export default {
  components: { Select2 },

  data() {
    const ahora = buildNowParts();

    return {
      GLOBAL,
      FACTOR_CONVERSION: 1.11112,

      person: null,
      permiso_lista: false,

      loading: false,
      error: null,

      fecha: ahora.fechaHora,
      fecha_inicio: null,
      fecha_final: null,

      fecha_doc: ahora.fecha,
      hora_doc: ahora.hora,
      fecha_doc_min: null,
      fecha_doc_max: null,

      facturadorService: null,
      clienteService: null,

      lista_clientes: [],
      cliente: null,
      cliente_identificacion: null,
      clienteticket: null,

      lista_metodo_pago: [],
      metodo_pago: null,

      lista_forma_pago: [],
      forma_pago: null,

      lista_uso_cfdi: [],
      uso_cfdi: null,

      lista_tipo_venta: [],
      tipo_venta: null,

      lista_perioricidad: [],
      perioricidad: null,
      observaciones: "",

      placa: "",
      consecutivo: "",
      search: {},

      reporte: [],
      lista_facturar: [],
      facturar: [],

      despacho_mensaje: null,
      seleccionTodos: false,

      boton_guardar_visible: true,
      boton_enviar_visible: false,
      boton_consultar_visible: false,

      boton_enviar_desabilitado: true,
      boton_consultar_desabilitado: true,

      personalizar_precio: false,
      total_precio: 0,
      total_precio_p: 0,
      total_precio_sin_impuesto: 0,
      total_facturar: 0,
      total_subtotal: 0,
      subtotal2: 0,
      total_descuento: 0,
      total_cantidad: 0,
      total_cantidad_m3: 0,
      total_precio_m3: 0,
      total_impuesto: 0,

      vista_subtal1: 0,
      vista_descuento: 0,

      factura_prefijo: null,
      factura_consecutivo: null,
      factura_uniqueid: null,
      factura_enviada: false,
      factura_sello: null,
      mostrar_periodo: false,

      pdf_url: null,
      uuid_sat: null,

      mensaje_guardando: false,
      mensaje_enviando: false,
      mensaje_consultando: false,
    };
  },

  watch: {
    fecha_doc(nuevo) {
      if (!this.esFechaValida(nuevo) || !this.estaFechaEnRango(nuevo)) {
        this.restaurarFechaDocumento();
        return;
      }
      this.actualizarFechaDocumento();
    },

    hora_doc(nuevo) {
      if (!this.esHoraValida(nuevo)) {
        this.restaurarHoraDocumento();
        return;
      }
      this.actualizarFechaDocumento();
    },
  },

  computed: {
    procesando() {
      return this.mensaje_guardando || this.mensaje_enviando || this.mensaje_consultando;
    },

    boton_pdf_visible() {
      return !!this.pdf_url;
    },

    botonPdfTexto() {
      return this.uuid_sat ? "VER FACTURA" : "PRE-FACTURA";
    },

    botonPdfClass() {
      return this.uuid_sat ? "btn-danger" : "btn-secondary";
    },
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(GLOBAL.PERMISOS.REPORTE.HOROMETRO);

    this.FACTOR_CONVERSION = 1;
    try {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
    } catch (error) { }

    this.facturadorService = new FacturadorService();
    this.clienteService = new ClienteService();

    const id = this.$route.fullPath.split("/").pop();
    if (GLOBAL.ES_UUID(id)) {
      this.facturadorService
        .getFacturaPreview(this.person, id)
        .then((data) => {
          const fact = data.data;

          this.total_precio = fact.items[0].precio;
          this.total_facturar = fact.venta_total;

          this.factura_prefijo = fact.prefijo;
          this.factura_consecutivo = fact.consecutivo;

          for (const u in fact.items) {
            fact.items[u].movimiento_id = null;
          }

          this.lista_facturar = fact.items;
          this.recalculo();

          if (fact.uniqueid) {
            this.factura_uniqueid = fact.uniqueid;
            this.armarPdfUrl(fact.uniqueid);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    this.configurarRangoFechaDocumento();
    this.asegurarFechaHoraDocumento();

    this.fecha_inicio = GLOBAL.NOW().split(" ")[0] + " 00:00";
    this.fecha_final = GLOBAL.NOW().split(" ")[0] + " 23:59";

    this.getCatalogos();
    this.getParametros();
    this.getListaClientes();
  },

  mounted() {
    $("input[datatype='fecha']").datetimepicker();
    this.configurarRangoFechaDocumento();
    this.asegurarFechaHoraDocumento();
    this.loading = false;
  },

  methods: {
    pad(valor) {
      return String(valor).padStart(2, "0");
    },

    getNowLocalParts() {
      return buildNowParts();
    },

    buildDatePartsFromDate(date) {
      return (
        date.getFullYear() +
        "-" +
        this.pad(date.getMonth() + 1) +
        "-" +
        this.pad(date.getDate())
      );
    },

    configurarRangoFechaDocumento() {
      const now = new Date();

      if (now.getTimezoneOffset() === 300) {
        now.setHours(now.getHours() - 1);
      }

      const min = new Date(now);
      min.setDate(min.getDate() - 2);

      this.fecha_doc_max = this.buildDatePartsFromDate(now);
      this.fecha_doc_min = this.buildDatePartsFromDate(min);
    },

    esFechaValida(fecha) {
      return /^\d{4}-\d{2}-\d{2}$/.test(fecha || "");
    },

    esHoraValida(hora) {
      return /^([01]\d|2[0-3]):([0-5]\d)$/.test(hora || "");
    },

    estaFechaEnRango(fecha) {
      if (!this.esFechaValida(fecha)) return false;
      if (!this.fecha_doc_min || !this.fecha_doc_max) return true;
      return fecha >= this.fecha_doc_min && fecha <= this.fecha_doc_max;
    },

    restaurarFechaDocumento() {
      const ahora = this.getNowLocalParts();

      if (this.estaFechaEnRango(ahora.fecha)) {
        this.fecha_doc = ahora.fecha;
      } else if (this.fecha_doc_max) {
        this.fecha_doc = this.fecha_doc_max;
      } else {
        this.fecha_doc = ahora.fecha;
      }

      this.actualizarFechaDocumento();
    },

    restaurarHoraDocumento() {
      const ahora = this.getNowLocalParts();
      this.hora_doc = ahora.hora;
      this.actualizarFechaDocumento();
    },

    asegurarFechaHoraDocumento() {
      const ahora = this.getNowLocalParts();

      if (!this.esFechaValida(this.fecha_doc) || !this.estaFechaEnRango(this.fecha_doc)) {
        this.fecha_doc = this.estaFechaEnRango(ahora.fecha)
          ? ahora.fecha
          : this.fecha_doc_max || ahora.fecha;
      }

      if (!this.esHoraValida(this.hora_doc)) {
        this.hora_doc = ahora.hora;
      }

      this.actualizarFechaDocumento();
    },

    asegurarSoloValoresDocumento() {
      const ahora = this.getNowLocalParts();

      if (!this.esFechaValida(this.fecha_doc) || !this.estaFechaEnRango(this.fecha_doc)) {
        this.fecha_doc = this.estaFechaEnRango(ahora.fecha)
          ? ahora.fecha
          : this.fecha_doc_max || ahora.fecha;
      }

      if (!this.esHoraValida(this.hora_doc)) {
        this.hora_doc = ahora.hora;
      }
    },

    normalizarHora(hora, incluirSegundos = true) {
      if (!this.esHoraValida(hora)) {
        const ahora = this.getNowLocalParts();
        return incluirSegundos ? `${ahora.hora}:00` : ahora.hora;
      }

      const partes = hora.split(":");
      const hh = this.pad(partes[0] || "00");
      const mm = this.pad(partes[1] || "00");
      const ss = this.pad(partes[2] || "00");

      return incluirSegundos ? `${hh}:${mm}:${ss}` : `${hh}:${mm}`;
    },

    unirFechaHora(fecha, hora) {
      const ahora = this.getNowLocalParts();
      const fechaFinal = this.esFechaValida(fecha) && this.estaFechaEnRango(fecha) ? fecha : ahora.fecha;
      const horaFinal = this.normalizarHora(hora, true);
      return `${fechaFinal} ${horaFinal}`;
    },

    actualizarFechaDocumento() {
      this.asegurarSoloValoresDocumento();
      this.fecha = this.unirFechaHora(this.fecha_doc, this.hora_doc);
    },

    onFechaDocChange() {
      this.asegurarFechaHoraDocumento();
    },

    onHoraDocChange() {
      this.asegurarFechaHoraDocumento();
    },

    onFechaDocBlur() {
      this.asegurarFechaHoraDocumento();
    },

    onHoraDocBlur() {
      this.asegurarFechaHoraDocumento();
    },

    armarPdfUrl(uniqueid) {
      const host = GLOBAL.SERVER_HOST;
      const empresa = this.person.empresas;
      this.pdf_url = host + "/kubber/facturacion/api/v1/generate/" + empresa + "/" + uniqueid;
    },

    abrirPdf() {
      if (!this.pdf_url) return;
      window.open(this.pdf_url, "_blank");
    },

    selectCliente(client) {
      this.cliente_identificacion = client.identificacion;

      if (client.id == "0") {
        this.tipo_venta = 72;
        this.metodo_pago = 48;
        this.uso_cfdi = 22;
        this.forma_pago = 50;
        this.mostrar_periodo = true;
      } else {
        this.mostrar_periodo = false;
      }

      this.evaluaCampos();
    },

    evaluaCampos() {
      this.asegurarFechaHoraDocumento();
      this.despacho_mensaje = "";
      this.error = null;

      if (!this.esFechaValida(this.fecha_doc)) this.error = "La fecha del documento es obligatoria";
      if (this.esFechaValida(this.fecha_doc) && !this.estaFechaEnRango(this.fecha_doc)) {
        this.error = "La fecha del documento solo puede estar entre hoy y dos días atrás";
      }
      if (!this.esHoraValida(this.hora_doc)) this.error = "La hora del documento es obligatoria";
      if (this.forma_pago == null || this.forma_pago == 0) this.error = "Seleccione la FORMA DE PAGO";
      if (this.uso_cfdi == null || this.uso_cfdi == 0) this.error = "Seleccione el USO DE CFDI de la lista";
      if (this.metodo_pago == null || this.metodo_pago == 0) this.error = "Seleccione el MÉTODO DE PAGO para la factura";
      if (this.tipo_venta == null || this.tipo_venta == 0) this.error = "Seleccione el tipo de venta CONTADO/CREDITO";
      if (this.lista_facturar.length === 0) this.error = "Seleccione los TICKET a procesar";
      if (this.cliente == null) this.error = "Seleccione un CLIENTE de la lista";

      if (this.cliente_identificacion === "XAXX010101000") {
        if (this.perioricidad == null) this.error = "Seleccione la perioricidad: DIARIA/QUINCENAL/MENSUAL";
      }
    },

    limpiarCliente() {
      this.clienteticket = null;
    },

    getParametros() {
      this.loading = true;
      this.facturadorService
        .getParametros(this.person)
        .then(() => {
          this.configurarRangoFechaDocumento();
          this.asegurarFechaHoraDocumento();
        })
        .catch(() => {
          this.configurarRangoFechaDocumento();
          this.asegurarFechaHoraDocumento();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getListaClientes() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          this.lista_clientes = [];
          this.lista_clientes.push({
            id: 0,
            text: "XAXX010101000 - PUBLICO GENERAL",
            identificacion: "XAXX010101000",
          });
          for (const i in data) {
            this.lista_clientes.push({
              id: data[i]._id,
              text: data[i].identificacion + " - " + data[i].nombres,
              identificacion: data[i].identificacion,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getCatalogos() {
      this.facturadorService.getCatalogos(this.person).then((json) => {
        for (const i in json) {
          switch (json[i].tipo) {
            case GLOBAL.CATALOGO_MEXICO.METODO_PAGO:
              this.lista_metodo_pago.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.FORMA_PAGO:
              this.lista_forma_pago.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.USO_CFDI:
              this.lista_uso_cfdi.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.TIPO_VENTA:
              this.lista_tipo_venta.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.PERIORICIDAD:
              this.lista_perioricidad.push(json[i]);
              break;
            default:
              break;
          }
        }
      });
    },

    getReporteVentasPendiente() {
      this.reporte = [];
      this.search = {};
      this.loading = true;

      if (this.placa !== "") this.search["placa"] = this.placa;
      if (this.consecutivo !== "") this.search["consecutivo"] = this.consecutivo;

      this.fecha_inicio = $("#fecha_inicio").val();
      this.fecha_final = $("#fecha_final").val();

      this.facturadorService
        .getListaMovimientosParaFacturar(
          this.person,
          this.fecha_inicio,
          this.fecha_final,
          this.clienteticket,
          GLOBAL.TIPO_ORIGEN.COMBUSTIBLE,
          this.search
        )
        .then((data) => {
          this.reporte = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatDateTimeZ(fechaTexto) {
      var nfecha = fechaTexto.trim().replace(" ", "T") + ".000Z";
      return nfecha;
    },

    generarFactura() {
      this.boton_enviar_desabilitado = true;
      this.boton_consultar_desabilitado = true;
      this.evaluaCampos();

      if (this.error == null) {
        const items = [];
        for (const i in this.lista_facturar) {
          let precio = this.total_precio;
          if (this.personalizar_precio) precio = this.total_precio;

          items.push({
            uniqueid: this.lista_facturar[i].uniqueid,
            despacho_id: this.lista_facturar[i]._id,
            despacho_prefijo: this.lista_facturar[i].prefijo,
            despacho_numero: this.lista_facturar[i].consecutivo,
            precio: precio,
          });
        }

        const request = {
          fecha: this.formatDateTimeZ(this.fecha),
          persona_uniqueid: this.person.persona_id,
          tercero_uniqueid: this.cliente,
          fecha_creacion: this.formatDateTimeZ(this.fecha),
          costo_total: 0,
          venta_subtotal: this.total_subtotal,
          impuesto_total: this.total_impuesto,
          descuento_total: this.total_descuento,
          venta_total: this.total_facturar,
          estado: "P",
          atributos: {
            tipo_venta: this.tipo_venta,
            metodo_pago: this.metodo_pago,
            uso_cfdi: this.uso_cfdi,
            forma_pago: this.forma_pago,
            perioricidad: this.perioricidad,
            observaciones: this.observaciones,
            precio_personalizado: this.personalizar_precio,
            precio_sin_iva: this.total_precio_p,
          },
          items: items,
        };

        this.mensaje_guardando = true;
        this.despacho_mensaje = "";

        this.facturadorService
          .crearFactura40Mexico(this.person, request)
          .then((data) => {
            if (typeof data !== "undefined" && data.status === 200) {
              this.despacho_mensaje = "¡Proceso realizado con éxito!, ahora puede enviarla al SAT";
              this.factura_prefijo = data.data.prefijo;
              this.factura_consecutivo = data.data.consecutivo;
              this.factura_uniqueid = data.data.uniqueid;
              this.factura_enviada = false;

              this.uuid_sat = null;
              this.armarPdfUrl(data.data.uniqueid);

              this.boton_guardar_visible = false;
              this.boton_enviar_visible = true;
              this.boton_consultar_visible = false;

              this.boton_enviar_desabilitado = false;
              this.boton_consultar_desabilitado = true;
            } else {
              this.despacho_mensaje = "Proceso no fué realizado, reintente nuevamente";
              this.boton_enviar_desabilitado = true;
              this.boton_consultar_desabilitado = true;
            }
          })
          .finally(() => {
            this.mensaje_guardando = false;
          });
      } else {
        this.despacho_mensaje = this.error;
      }
    },

    enviarFactura() {
      this.boton_enviar_desabilitado = true;
      this.boton_consultar_desabilitado = true;

      const request = { uniqueid: this.factura_uniqueid };
      this.mensaje_enviando = true;
      this.despacho_mensaje = "";

      this.facturadorService
        .enviarFactura40Mexico(this.person, request)
        .then((data) => {
          if (typeof data !== "undefined") {
            if (data.status === 200) {
              if (data.data && data.data.success === false) {
                this.despacho_mensaje =
                  data.data.mensaje ||
                  "El SAT devolvió un error, por favor revise e intente nuevamente.";

                this.boton_enviar_desabilitado = false;
                this.boton_consultar_desabilitado = true;
                return;
              }

              this.despacho_mensaje = "Factura enviada correctamente al SAT";

              this.boton_guardar_visible = false;
              this.boton_enviar_visible = false;
              this.boton_consultar_visible = true;

              this.boton_enviar_desabilitado = true;
              this.boton_consultar_desabilitado = false;

              this.consultaFactura();
            } else {
              this.despacho_mensaje = "Proceso no fué realizado, reintente nuevamente";
              this.boton_enviar_desabilitado = false;
              this.boton_consultar_desabilitado = true;
            }
          } else {
            this.despacho_mensaje = "Proceso no se realizó, contacte a soporte";
            this.boton_enviar_desabilitado = false;
            this.boton_consultar_desabilitado = true;
          }
        })
        .finally(() => {
          this.mensaje_enviando = false;
        });
    },

    consultaFactura() {
      const request = { uniqueid: this.factura_uniqueid };
      this.despacho_mensaje = "";
      this.boton_consultar_desabilitado = true;
      this.mensaje_consultando = true;
      this.mensaje_guardando = false;

      this.facturadorService
        .consultaFactura40Mexico(this.person, request)
        .then((data) => {
          if (data.status === 200) {
            if (data.data.uuid_sat == null) {
              this.despacho_mensaje = "REINTENTE PARA CONSULTAR SI HA SIDO TIMBRADA";
              this.boton_consultar_desabilitado = false;
            } else {
              this.uuid_sat = data.data.uuid_sat;
              this.despacho_mensaje = "SAT UUID: " + data.data.uuid_sat;

              this.boton_enviar_desabilitado = true;
              this.boton_consultar_desabilitado = true;

              this.factura_enviada = true;
            }

            this.factura_sello = data.data.sello;
          } else {
            this.despacho_mensaje = "Proceso no fué realizado, reintente nuevamente";
            this.boton_consultar_desabilitado = false;
          }
        })
        .finally(() => {
          this.mensaje_consultando = false;
          this.mensaje_enviando = false;
          this.mensaje_guardando = false;
        });
    },

    selectAll() {
      this.seleccionTodos = !this.seleccionTodos;
      if (this.seleccionTodos) {
        for (const i in this.reporte) this.selectMe(this.reporte[i], true);
      } else {
        for (const i in this.reporte) this.deselectMe(this.reporte[i], true);
      }
      this.recalculo();
    },

    selectMe(ticket, selectAll) {
      const index = this.lista_facturar.findIndex((item) => item._id === ticket._id);

      let agregar = true;
      if (typeof this.lista_facturar[0] !== "undefined") {
        const item0 = this.lista_facturar[0];
        if (item0.precio === ticket.precio && item0.tercero_nit === ticket.tercero_nit) {
          agregar = true;
        } else {
          agregar = false;
        }
      }

      if (index === -1 && agregar) {
        if (ticket.movimiento_id == null) {
          this.lista_facturar.push(ticket);
          ticket.selected = true;
        }
        if (!selectAll) this.recalculo();
      }
    },

    deselectMe(ticket, selectAll) {
      const index = this.lista_facturar.indexOf(ticket);
      if (index > -1) this.lista_facturar.splice(index, 1);
      ticket.selected = false;
      if (!selectAll) this.recalculo();
    },

    recalculo() {
      this.total_facturar = 0;
      this.total_precio = 0;
      this.total_descuento = 0;
      this.total_subtotal = 0;
      this.total_cantidad = 0;
      this.total_cantidad_m3 = 0;
      this.total_precio_m3 = 0;
      this.total_impuesto = 0;
      this.total_precio_sin_impuesto = 0;

      this.vista_descuento = 0;
      this.vista_subtal1 = 0;
      this.subtotal2 = 0;

      for (const i in this.lista_facturar) {
        this.total_descuento += this.lista_facturar[i].descuento_total;

        if (this.personalizar_precio) {
          if (this.person.empresas == GLOBAL.EMPRESAS.KUBBER || this.person.empresas == GLOBAL.EMPRESAS.VALSEQUILLO) {
            var cantidad = this.lista_facturar[i].cantidad;
            var cantidadM3 = cantidad / this.FACTOR_CONVERSION;
            this.total_cantidad += cantidad;
            this.total_cantidad_m3 += cantidadM3;

            // Caso: IVA incluido, desglosarlo del precio total
            this.total_precio = this.formatDecimal(this.total_precio_p * 1.16, 2);

            // Desglosar IVA del precio
            this.total_precio_sin_impuesto = this.formatDecimal(
              this.total_precio_p,
              2
            );

            this.total_precio_m3 = this.total_precio_p * this.FACTOR_CONVERSION;

            this.total_subtotal = this.total_cantidad_m3 * this.total_precio_m3;

            // Sumar el impuesto desglosado
            this.total_impuesto = this.formatDecimal(
              this.total_subtotal * 0.16,
              2
            );

            // Total a facturar
            this.total_facturar = this.total_subtotal + this.total_impuesto;


          } else {

            var cantidad = this.lista_facturar[i].cantidad;
            var cantidadM3 = cantidad / this.FACTOR_CONVERSION;
            this.total_cantidad += cantidad;
            this.total_cantidad_m3 += cantidadM3;

            // Caso: IVA incluido, desglosarlo del precio total
            this.total_precio = this.formatDecimal(this.total_precio_p * 1.16, 2);

            // Desglosar IVA del precio
            this.total_precio_sin_impuesto = this.formatDecimal(
              this.total_precio_p,
              2
            );

            this.total_precio_m3 = this.total_precio_p * this.FACTOR_CONVERSION;

            this.total_subtotal = this.total_cantidad_m3 * this.total_precio_m3;

            // Sumar el impuesto desglosado
            this.total_impuesto = this.formatDecimal(
              this.total_subtotal * 0.16,
              2
            );

            // Total a facturar
            this.total_facturar = this.total_subtotal + this.total_impuesto;
          }
        } else {
          const cantidad = this.formatDecimal(this.lista_facturar[i].cantidad, 2);
          const cantidadM3 = this.formatDecimal(cantidad / this.FACTOR_CONVERSION, 2);
          this.total_cantidad += cantidad;
          this.total_cantidad_m3 += cantidadM3;

          this.total_precio = this.lista_facturar[i].precio;
          this.total_precio_p = this.lista_facturar[i].precio;

          this.total_precio_sin_impuesto = this.formatDecimal(this.total_precio / 1.16, 2);
          this.total_precio_m3 = this.formatDecimal(this.total_precio_sin_impuesto * this.FACTOR_CONVERSION, 2);

          const subtotal1 = cantidad * this.total_precio_sin_impuesto;

          this.vista_subtal1 += cantidadM3 * this.total_precio_m3;

          const subt2 = this.lista_facturar[i].venta_total / 1.16;
          this.subtotal2 += subt2;

          this.vista_descuento += this.formatDecimal(subtotal1 - subt2, 2);

          const vtotal = this.lista_facturar[i].venta_total;
          const impuesto = vtotal - subt2;

          this.total_subtotal += subtotal1;
          this.total_impuesto += this.formatDecimal(impuesto, 2);
          this.total_facturar += this.lista_facturar[i].venta_total;
        }
      }
    },

    formatDecimal(value, decimal) {
      const factor = Math.pow(10, decimal);
      return Math.round(value * factor) / factor;
    },
  },
};
</script>

<style scoped>
.area-facturas-fecha {
  font-size: 12px;
}

.area-facturas-placa-cliente {
  margin-bottom: -8px;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: -1px;
}

.acciones-bottom {
  width: 90%;
  margin: 10px auto 20px auto;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #e3e3e3;
  padding-top: 12px;
}

.acciones-mensajes {
  flex: 1;
  min-width: 240px;
}

.acciones-estado {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 14px;
}

.acciones-icon {
  width: 22px;
  height: 22px;
}

.acciones-msg {
  margin-top: 8px;
  font-size: 14px;
  padding: 10px;
  border: 1px dashed #cfcfcf;
  border-radius: 6px;
  background: #fafafa;
}

.uuid-sat {
  margin-top: 8px;
  font-size: 13px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  background: #fff;
}

.acciones-botones {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.no-permiso {
  width: 90%;
  margin: 8px auto;
  font-size: 13px;
  color: #a00;
}
</style>